import React, { useEffect, useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS, CONTACT } from "../mock";

const Reviews = () => {
  const [perPage, setPerPage] = useState(4);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const calc = () => {
      const w = window.innerWidth;
      if (w < 640) setPerPage(1);
      else if (w < 1080) setPerPage(2);
      else setPerPage(4);
    };
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, []);

  const totalPages = Math.max(1, REVIEWS.length - perPage + 1);
  const safeIndex = Math.min(index, totalPages - 1);

  // Auto-advance
  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % totalPages);
    }, 4500);
    return () => clearInterval(t);
  }, [totalPages]);

  const cardWidth = `calc((100% - ${(perPage - 1) * 22}px) / ${perPage})`;
  const offset = `calc(${safeIndex} * (-1 * (${cardWidth} + 22px)))`;

  return (
    <section id="reviews" className="reviews-section">
      <div className="container">
        <div className="reviews-head">
          <span className="section-label center">Client Testimonials</span>
          <h2 className="section-title">What People Say About<br/><em>Guruji</em></h2>
        </div>

        <div className="google-summary">
          <div className="rating-num">4.8</div>
          <div>
            <div className="stars">
              {[1,2,3,4].map(i => <Star key={i} size={18} fill="currentColor" />)}
              <Star size={18} fill="currentColor" style={{ opacity: 0.55 }} />
            </div>
            <p>Based on Google Reviews · KR Puram, Bengaluru</p>
          </div>
          <a href={CONTACT.googleMapsLink} target="_blank" rel="noreferrer" className="gbtn">
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.35-8.16 2.35-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            View on Google
          </a>
        </div>

        <div className="reviews-carousel-wrap" style={{ overflow: "hidden" }}>
          <div className="reviews-track" style={{ transform: `translateX(${offset})` }}>
            {REVIEWS.map((r, i) => (
              <article className="review-card" key={i}>
                <div className="gbadge">
                  <svg width="12" height="12" viewBox="0 0 48 48">
                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.35-8.16 2.35-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                  </svg>
                </div>
                <div className="review-stars">
                  {Array.from({ length: r.stars }).map((_, idx) => (
                    <Star key={idx} size={14} fill="currentColor" />
                  ))}
                </div>
                <p className="review-text">“{r.text}”</p>
                <div className="review-author">
                  <div className="review-avatar" style={{ background: r.color }}>{r.name.charAt(0)}</div>
                  <div>
                    <div className="review-author-name">{r.name}</div>
                    <div className="review-author-date">{r.city} · Google Review</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="reviews-nav">
          <button className="reviews-btn" onClick={() => setIndex((i) => (i - 1 + totalPages) % totalPages)} aria-label="Previous"><ChevronLeft size={18} /></button>
          <div className="reviews-dots">
            {Array.from({ length: totalPages }).map((_, i) => (
              <button
                key={i}
                className={`reviews-dot ${i === safeIndex ? "active" : ""}`}
                onClick={() => setIndex(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
          <button className="reviews-btn" onClick={() => setIndex((i) => (i + 1) % totalPages)} aria-label="Next"><ChevronRight size={18} /></button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
